import { render, staticRenderFns } from "./CetakKajianMedis.vue?vue&type=template&id=981d3868&"
import script from "./CetakKajianMedis.vue?vue&type=script&lang=js&"
export * from "./CetakKajianMedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports